interface UseInViewOptions {
	threshold?: number
	root?: Element | null
	rootMargin?: string
}

export function useInternalScrollView(
	elRef: Ref<Element | null>,
	inViewOptions: UseInViewOptions = { threshold: 1.0, root: null, rootMargin: '0px' }
) {
	const isInView = ref(false)
	let observer: IntersectionObserver | null = null

	const callback: IntersectionObserverCallback = entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting && entry.intersectionRatio >= (inViewOptions.threshold ?? 1.0)) {
				isInView.value = true
				observer?.disconnect() // Disconnect observer once in view to improve performance
			}
		})
	}

	onMounted(() => {
		if (elRef.value) {
			observer = new IntersectionObserver(callback, inViewOptions)
			observer.observe(elRef.value)
		}
	})

	onUnmounted(() => {
		observer?.disconnect()
	})

	return { isInView }
}
